module.exports = __webpack_public_path__ + "img/horizontal_3_2_8011.2ac4f57d.png";